module.exports = __webpack_public_path__ + "static/media/sakred-glassware-collection-karim-rashid.d25040f8.jpg";